
<template>
  <div>
    <van-nav-bar
      title="活动列表"
      fixed
      placeholder
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <div class="mt-2">
      <van-tabs type="card" color="#49cfd4" animated>
        <van-tab title="当前活动">
          <div>
            <div class="mt-1"></div>
            <div class="mt-1 max-h-64 mb-2 overflow-y-auto">
              <van-empty
                description="暂无活动"
                v-if="activeEvents.length == 0"
              />
              <div
                v-else
                class="
                  p-1
                  mx-1
                  mt-0.5
                  rounded-sm
                  bg-white
                  grid grid-rows-4 grid-flow-col
                "
                @click="showEventDetail(event)"
                v-for="event in activeEvents"
                :key="event.id"
              >
                <div class="justify-self-start">
                  <span class="small-text text-gray">{{
                    event.activityInfo.title
                  }}</span>
                </div>

                <div class="justify-self-start">
                  <span class="small-text text-gray-500"
                    >地点：{{ event.activityInfo.place }}</span
                  >
                </div>
                <div class="justify-self-start">
                  <span class="small-text text-gray-500"
                    >时间：{{
                      event.activityInfo.beginTime.date.slice(5, 16)
                    }}-{{ event.activityInfo.endTime.date.slice(11, 16) }}</span
                  >
                </div>
                <div class="justify-self-start">
                  <span class="small-text text-gray-500"
                    >报名截止：{{
                      event.activityInfo.deadline.date.slice(5, 16)
                    }}</span
                  >
                </div>
                <div class="row-span-4 justify-self-end">
                  <van-image
                    width="80"
                    height="80"
                    lazy-load
                    :src="event.activityInfo.filePath"
                  />
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="历史活动">
          <div>
            <div class="mt-1"></div>
            <div class="mt-1 max-h-64 mb-2 overflow-y-auto">
              <van-empty description="暂无活动" v-if="pastEvents.length == 0" />
              <div
                v-else
                class="
                  p-1
                  mx-1
                  mt-0.5
                  rounded-sm
                  bg-white
                  grid grid-rows-4 grid-flow-col
                "
                @click="showEventDetail(event)"
                v-for="event in pastEvents"
                :key="event.id"
              >
                <div class="justify-self-start">
                  <span class="small-text text-gray">{{
                    event.activityInfo.title
                  }}</span>
                </div>

                <div class="justify-self-start">
                  <span class="small-text text-gray-500"
                    >地点：{{ event.activityInfo.place }}</span
                  >
                </div>
                <div class="justify-self-start">
                  <span class="small-text text-gray-500"
                    >时间：{{
                      event.activityInfo.beginTime.date.slice(5, 16)
                    }}-{{ event.activityInfo.endTime.date.slice(11, 16) }}</span
                  >
                </div>
                <div class="justify-self-start">
                  <span class="small-text text-gray-500"
                    >报名截止：{{
                      event.activityInfo.deadline.date.slice(5, 16)
                    }}</span
                  >
                </div>
                <div class="row-span-4 justify-self-end">
                  <van-image
                    width="80"
                    height="80"
                    lazy-load
                    :src="event.activityInfo.filePath"
                  />
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-dialog v-model:show="eventShown" title="活动详情">
      <div
        class="
          mx-2
          mt-1
          p-1
          filter
          drop-shadow-md
          rounded-sm
          bg-white
          grid grid-cols-3
          items-center
          gap-0.5
        "
      >
        <div class="col-span-2 small-text text-bold">{{ selectedEvent.title }}</div>
        <div class="col-span-3 text-gray-500">{{ selectedEvent.abstract }}</div>
        <div class="col-span-3 text-gray-500">
          <van-icon name="location" />{{ selectedEvent.place }}
        </div>
        <div class="place-self-center small-text text-bold">
          {{ selectedEvent.organizer }}
        </div>
        <div class="place-self-center small-text text-bold">
          {{ selectedEvent.contact }}
        </div>
        <div class="place-self-center small-text text-bold">
          {{ selectedEvent.tel }}
        </div>
        <div class="place-self-center text-gray-500">主办方</div>
        <div class="place-self-center text-gray-500">联系人</div>
        <div class="place-self-center text-gray-500">联系方式</div>
      </div>
      <div class="mx-2 mt-1 p-1 rounded-sm bg-white">
        <div class="middle-text text-bold">活动详情</div>
        <div class="text-gray-500 small-text desc">
          {{ selectedEvent.content }}
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getMyEvents } from "@/service/home";
import dayjs from 'dayjs';
import Cookies from "js-cookie";
export default {
  name: "myevents",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      activeEvents: [],
      pastEvents: [],
      eventShown: false,
      selectedEvent: {}
    });
    onMounted(async () => {
      const { data:{list: events} } = await getMyEvents({
        access_token: user.access_token,
        userid: user.userid,
      });
      state.activeEvents = events.filter((event) => dayjs().isBefore(dayjs(event.activityInfo.endTime.date)));
      state.pastEvents = events.filter((event) => dayjs().isAfter(dayjs(event.activityInfo.endTime.date)));
    });
    const goBack = () => router.go(-1);
    const showEventDetail = (event) => {
      state.eventShown = true;
      state.selectedEvent = event;
    };
    return {
      goBack,
      showEventDetail,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" >
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.van-cell__title {
  flex: 1 1 auto;
}
.van-cell__value {
  flex: 1 1 auto;
}
</style>
